<div class="particulars-container" *ngIf="record?.recordType === 'INDIVIDUAL'">
  <div class="particular">
    <div class="particular__label">
      <ng-container *ngIf="crp?.primary ; else crpName">
        {{ 'customer_type.individual.form.label.name' | translate }}
      </ng-container>
      <ng-template #crpName>
        {{ 'customer_type.individual.form.label.individual_crp_name' | translate }}
      </ng-template>
    </div>
    <div class="particular__value">{{record?.name}}</div>
  </div>
  <div class="particular">
    <div class="particular__label"> {{ 'customer_type.individual.form.label.salutation' | translate }} </div>
    <div class="particular__value">{{record?.title ? record?.title : '-'}}</div>
  </div>
  <div class="particular">
    <div class="particular__label"> {{ 'customer_type.individual.form.label.is_active' | translate }} </div>
    <div class="particular__value">{{customer?.isActiveCustomer ? 'YES' : 'NO'}}</div>
  </div>
  <div class="particular particular_multi-values">
    <div class="particular__label"> {{ 'customer_type.individual.form.label.alias_name' | translate }} </div>
    <div class="particular__value" *ngIf="!record?.aliasNames.length">-</div>
    <ng-container *ngFor="let aliasName of record?.aliasNames; let i = index">
      <div class="particular__label">{{ 'customer_type.individual.form.label.alias_name' | translate }} #{{i+1}}</div>
      <div class="particular__value">{{aliasName}}</div>
    </ng-container>
  </div>
  <div class="particular particular_multi-values">
    <div class="particular__label"> {{ 'customer_type.individual.form.label.former_registered_name' | translate }} </div>
    <div class="particular__value" *ngIf="!record?.oldNames.length">-</div>
    <ng-container *ngFor="let oldName of record?.oldNames; let i = index">
      <div class="particular__label">{{ 'customer_type.individual.form.label.former_registered_name' | translate }} #{{i+1}}</div>
      <div class="particular__value">{{oldName}}</div>
    </ng-container>
  </div>
  <div class="particular">
    <div class="particular__label"> {{ 'customer_type.individual.form.label.gender' | translate }} </div>
    <div class="particular__value">{{record?.gender}}</div>
  </div>
  <div class="particular">
    <div class="particular__label"> {{ 'customer_type.individual.form.label.nationality' | translate }} </div>
    <div class="particular__value">{{record?.nationality}}</div>
  </div>
  <div class="particular">
    <div class="particular__label"> {{ 'customer_type.individual.form.label.country_of_residence' | translate }} </div>
    <div class="particular__value">{{record?.countryOfResidence}}</div>
  </div>
  <div class="particular">
    <div class="particular__label"> {{ 'customer_type.individual.form.label.country_of_birth' | translate }} </div>
    <div class="particular__value">{{record?.countryOfBirth ? record?.countryOfBirth : '-'}}</div>
  </div>
  <div class="particular">
    <div class="particular__label"> {{ 'customer_type.individual.form.label.identity_document_type' | translate }} </div>
    <div class="particular__value">{{record?.idType ? record?.idType : '-'}}</div>
  </div>
  <div class="particular">
    <div class="particular__label"> {{ 'customer_type.individual.form.label.identification_number' | translate }} </div>
    <div class="particular__value">{{record?.idNumber ? record?.idNumber : '-'}}</div>
  </div>
  <div class="particular">
    <div class="particular__label"> {{ 'customer_type.individual.form.label.date_of_identity_issue' | translate }} </div>
    <div class="particular__value">{{record?.idIssueDate ? (record?.idIssueDate | date:'dd/MM/yyyy') : '-'}}</div>
  </div>
  <div class="particular">
    <div class="particular__label"> {{ 'customer_type.individual.form.label.date_of_identity_expiry' | translate }} </div>
    <div class="particular__value">{{record?.idExpiryDate ? (record?.idExpiryDate | date:'dd/MM/yyyy') : '-'}}</div>
  </div>
  <div class="particular">
    <div class="particular__label"> {{ 'customer_type.individual.form.label.birth_date' | translate }} </div>
    <div class="particular__value">{{record?.dateOfBirth ? (record?.dateOfBirth | date:'dd/MM/yyyy') : '-'}}</div>
  </div>
  <ng-container *ngIf="crp?.primary">
    <div class="particular">
      <div class="particular__label"> {{ 'customer_type.individual.form.label.industry' | translate }} </div>
      <div class="particular__value">{{record?.industry}}</div>
    </div>
    <div class="particular">
      <div class="particular__label"> {{ 'customer_type.individual.form.label.occupation' | translate }} </div>
      <div class="particular__value">{{record?.occupation}}</div>
    </div>
    <div class="particular">
      <div class="particular__label"> {{ 'customer_type.individual.form.label.onboarding_mode' | translate }} </div>
      <div class="particular__value">{{customer?.onboardingMode}}</div>
    </div>
    <div class="particular">
      <div class="particular__label"> {{ 'customer_type.individual.form.label.payment_mode' | translate }} </div>
      <div class="particular__value">{{customer?.paymentModes.join(', ')}}</div>
    </div>
    <div class="particular" *ngIf="dataAvailableFormFields?.jsonValue?.sourceOfWealth?.visible">
      <div class="particular__label"> {{ 'customer_type.individual.form.label.source_of_wealth' | translate }} </div>
      <div class="particular__value">{{customer?.sourceOfWealth?.length > 0 ? customer?.sourceOfWealth.join(', ') : '-'}}</div>
    </div>
    <div class="particular" *ngIf="dataAvailableFormFields?.jsonValue?.annualIncomeLevel?.visible">
      <div class="particular__label"> {{ 'customer_type.individual.form.label.annual_income_level_usd' | translate }} </div>
      <div class="particular__value">{{customer?.annualIncomeLevel || '-'}}</div>
    </div>
    <div class="particular">
      <div class="particular__label"> {{ 'customer_type.individual.form.label.product_service_complexity' | translate }} </div>
      <div class="particular__value">{{customer?.productServiceComplexity}}</div>
    </div>
    <div class="particular">
      <div class="particular__label"> {{ 'customer_type.individual.form.label.source_of_funds' | translate }} </div>
      <div class="particular__value">{{record?.sourceOfFunds !== '' ? record?.sourceOfFunds : '-'}}</div>
    </div>
  </ng-container>
  <div class="particular particular_multi-values">
    <div class="particular__label"> {{ 'customer_type.individual.form.label.address' | translate }} </div>
    <div class="particular__value" *ngIf="!record?.addresses.length">-</div>
    <ng-container *ngFor="let address of record?.addresses; let i = index">
      <div class="particular__label">{{ 'customer_type.individual.form.label.address' | translate }} #{{i+1}}</div>
      <div class="particular__value">{{address}}</div>
    </ng-container>
  </div>
  <div class="particular particular_multi-values">
    <div class="particular__label"> {{ 'customer_type.individual.form.label.phone_number' | translate }} </div>
    <div class="particular__value" *ngIf="!record?.phoneNumbers.length">-</div>
    <ng-container *ngFor="let phoneNumber of record?.phoneNumbers; let i = index">
      <div class="particular__label">{{ 'customer_type.individual.form.label.phone_number' | translate }} #{{i+1}}</div>
      <div class="particular__value">{{phoneNumber}}</div>
    </ng-container>
  </div>
  <div class="particular particular_multi-values">
    <div class="particular__label"> {{ 'customer_type.individual.form.label.email_address' | translate }} </div>
    <div class="particular__value" *ngIf="!record?.emailAddresses.length">-</div>
    <ng-container *ngFor="let emailAddress of record?.emailAddresses; let i = index">
      <div class="particular__label"> {{ 'customer_type.individual.form.label.email_address' | translate }} #{{i+1}}</div>
      <div class="particular__value">{{emailAddress}}</div>
    </ng-container>
  </div>
  <div class="particular particular_multi-values">
    <div class="particular__label"> {{ 'customer_type.individual.form.label.bank_account' | translate }} </div>
    <div class="particular__value" *ngIf="!record?.bankAccounts.length">-</div>
    <ng-container *ngFor="let bankAccount of record?.bankAccounts; let i = index">
      <div class="particular__label"> {{ 'customer_type.individual.form.label.bank_account' | translate }} #{{i+1}}</div>
      <div class="particular__value">{{bankAccount}}</div>
    </ng-container>
  </div>
  <div class="particular" *ngIf="crp?.primary">
    <div class="particular__label">
      {{ 'customer_type.individual.form.label.customer_reference_number' | translate }}
      <img class="themified-white-icon particular__info-icon" src="/assets/icons/info-icon.png" matTooltip="Unique ID of this case">
    </div>
    <div class="particular__value">{{customer?.referenceId !== '' ? customer?.referenceId : '-'}}</div>
  </div>
  <div class="particular">
    <div class="particular__label">
      {{ 'customer_type.individual.form.label.reference_number' | translate }}
      <img class="themified-white-icon particular__info-icon" src="/assets/icons/info-icon.png" matTooltip="Unique ID of this individual/corporate">
    </div>
    <div class="particular__value">{{record?.referenceId !== '' ? record?.referenceId : '-'}}</div>
  </div>
  <div class="particular" *ngIf="crp?.primary">
    <div class="particular__label"> {{ 'customer_type.individual.form.label.nature_of_business_relationship' | translate }} </div>
    <div class="particular__value">{{customer?.natureOfBusinessRelationship !== '' ? customer?.natureOfBusinessRelationship : '-'}}</div>
  </div>
  <div class="particular" *ngIf="!crp?.primary">
    <div class="particular__label"> {{ 'customer_type.individual.form.label.is_undischarged_bankrupt' | translate }} </div>
    <div class="particular__value">{{record?.isUndischargedBankrupt ? 'YES' : 'NO'}}</div>
  </div>
  <div class="particular" *ngIf="dataAvailableFormFields?.jsonValue?.policyCount?.visible">
    <div class="particular__label">{{ 'customer_type.individual.form.label.policy_count' | translate }} </div>
    <div class="particular__value">{{customer?.policyCount ? customer?.policyCount : '-'}}</div>
  </div>
  <div class="particular" *ngIf="dataAvailableFormFields?.jsonValue?.premiumAmount?.visible">
    <div class="particular__label">{{ 'customer_type.individual.form.label.premium_amount' | translate }} </div>
    <div class="particular__value">{{customer?.premiumAmount ? customer?.premiumAmount : '-'}}</div>
  </div>
</div>
<div class="particulars-container" *ngIf="record?.recordType === 'CORPORATE'">
  <div class="particular particular_company-name">
    <div class="particular__label">
      <ng-container *ngIf="crp?.primary ; else crpName">
        {{ 'customer_type.corporate.form.label.company_name' | translate }}
      </ng-container>
      <ng-template #crpName>
        {{ 'customer_type.corporate.form.label.corporate_crp_name' | translate }}
      </ng-template>
    </div>
    <div class="particular__value">{{record?.name}}</div>
  </div>
  <div class="particular particular_multi-values">
    <div class="particular__label"> {{ 'customer_type.corporate.form.label.alias_name' | translate }} </div>
    <div class="particular__value" *ngIf="!record?.aliasNames.length">-</div>
    <ng-container *ngFor="let aliasName of record?.aliasNames; let i = index">
      <div class="particular__label">{{ 'customer_type.corporate.form.label.alias_name' | translate }} #{{i+1}}</div>
      <div class="particular__value">{{aliasName}}</div>
    </ng-container>
  </div>
  <div class="particular particular_multi-values">
    <div class="particular__label"> {{ 'customer_type.corporate.form.label.former_registered_name' | translate }} </div>
    <div class="particular__value" *ngIf="!record?.oldNames.length">-</div>
    <ng-container *ngFor="let oldName of record?.oldNames; let i = index">
      <div class="particular__label">{{ 'customer_type.corporate.form.label.former_registered_name' | translate }} #{{i+1}}</div>
      <div class="particular__value">{{oldName}}</div>
    </ng-container>
  </div>
  <div class="particular">
    <div class="particular__label"> {{ 'customer_type.individual.form.label.is_active' | translate }} </div>
    <div class="particular__value">{{customer?.isActiveCustomer ? 'YES' : 'NO'}}</div>
  </div>
  <div class="particular">
    <div class="particular__label"> {{ 'customer_type.individual.form.label.is_incorporated' | translate }} </div>
    <div class="particular__value">{{record?.isIncorporated ? 'YES' : 'NO'}}</div>
  </div>
  <div class="particular">
    <div class="particular__label"> {{ 'customer_type.corporate.form.label.entity_type' | translate }} </div>
    <div class="particular__value">{{record?.entityType}}</div>
  </div>
  <div class="particular">
    <div class="particular__label"> {{ 'customer_type.corporate.form.label.ownership_structure_layer' | translate }} </div>
    <div class="particular__value">{{record?.ownershipStructureLayers}}</div>
  </div>
   <div *ngIf="crp?.primary" class="particular">
    <div class="particular__label"> {{ 'customer_type.corporate.form.label.is_uhc_fatf_jurisdiction' | translate }} </div>
    <div class="particular__value">{{record?.inFatfJurisdiction ? 'YES' : 'NO'}}</div>
  </div>
  <div class="particular">
    <div class="particular__label"> {{ 'customer_type.corporate.form.label.country_of_incorporation' | translate }} </div>
    <div class="particular__value">{{record?.countryOfIncorporation}}</div>
  </div>
  <div class="particular">
    <div class="particular__label"> {{ 'customer_type.corporate.form.label.country_of_major_operation' | translate }} </div>
    <div class="particular__value">{{record?.countryOfOperations}}</div>
  </div>
  <div class="particular" *ngIf="crp?.primary">
    <div class="particular__label"> {{ 'customer_type.corporate.form.label.date_of_incorporation' | translate }} </div>
    <div class="particular__value">{{record?.incorporationDate ? (record?.incorporationDate | date:'dd/MM/yyyy') : '-'}}</div>
  </div>
  <div class="particular" *ngIf="crp?.primary">
    <div class="particular__label"> {{ 'customer_type.corporate.form.label.date_of_incorporation_expiry' | translate }} </div>
    <div class="particular__value">{{record?.incorporationExpiryDate ? (record?.incorporationExpiryDate | date:'dd/MM/yyyy') : '-'}}</div>
  </div>
  <ng-container *ngIf="crp?.primary">
    <div class="particular">
      <div class="particular__label"> {{ 'customer_type.corporate.form.label.primary_business_activity' | translate }} </div>
      <div class="particular__value">{{record?.businessActivity}}</div>
    </div>
    <div class="particular">
      <div class="particular__label"> {{ 'customer_type.corporate.form.label.onboarding_mode' | translate }} </div>
      <div class="particular__value">{{customer?.onboardingMode}}</div>
    </div>
    <div class="particular">
      <div class="particular__label"> {{ 'customer_type.corporate.form.label.payment_mode' | translate }} </div>
      <div class="particular__value">{{customer?.paymentModes.join(', ')}}</div>
    </div>
    <div class="particular">
      <div class="particular__label"> {{ 'customer_type.corporate.form.label.product_service_complexity' | translate }} </div>
      <div class="particular__value">{{customer?.productServiceComplexity}}</div>
    </div>
  </ng-container>
  <div class="particular">
    <div class="particular__label"> {{ 'customer_type.corporate.form.label.source_of_funds' | translate }} </div>
    <div class="particular__value">{{record?.sourceOfFunds !== '' ? record?.sourceOfFunds : '-'}}</div>
  </div>
  <div class="particular">
    <div class="particular__label"> {{ 'customer_type.corporate.form.label.incorporation_number' | translate }} </div>
    <div class="particular__value">{{record?.incorporationNumber !== '' ? record?.incorporationNumber : '-'}}</div>
  </div>
  <div class="particular">
    <div class="particular__label"> {{ 'customer_type.corporate.form.label.imo_number' | translate }} </div>
    <div class="particular__value">{{record?.imoNumber !== '' ? record?.imoNumber : '-'}}</div>
  </div>
  <div class="particular">
    <div class="particular__label"> {{ 'customer_type.corporate.form.label.website' | translate }} </div>
    <div class="particular__value">{{record?.website !== '' ? record?.website : '-'}}</div>
  </div>
  <div class="particular particular_multi-values">
    <div class="particular__label">  {{ 'customer_type.corporate.form.label.address' | translate }} </div>
    <div class="particular__value" *ngIf="!record?.addresses.length">-</div>
    <ng-container *ngFor="let address of record?.addresses; let i = index">
      <div class="particular__label"> {{ 'customer_type.corporate.form.label.address' | translate }} #{{i+1}}</div>
      <div class="particular__value">{{address}}</div>
    </ng-container>
  </div>
  <div class="particular particular_multi-values">
    <div class="particular__label"> {{ 'customer_type.corporate.form.label.phone_number' | translate }} </div>
    <div class="particular__value" *ngIf="!record?.phoneNumbers.length">-</div>
    <ng-container *ngFor="let phoneNumber of record?.phoneNumbers; let i = index">
      <div class="particular__label"> {{ 'customer_type.corporate.form.label.phone_number' | translate }} #{{i+1}}</div>
      <div class="particular__value">{{phoneNumber}}</div>
    </ng-container>
  </div>
  <div class="particular particular_multi-values">
    <div class="particular__label"> {{ 'customer_type.corporate.form.label.email_address' | translate }} </div>
    <div class="particular__value" *ngIf="!record?.emailAddresses.length">-</div>
    <ng-container *ngFor="let emailAddress of record?.emailAddresses; let i = index">
      <div class="particular__label"> {{ 'customer_type.corporate.form.label.email_address' | translate }} #{{i+1}}</div>
      <div class="particular__value">{{emailAddress}}</div>
    </ng-container>
  </div>
  <div class="particular particular_multi-values">
    <div class="particular__label"> {{ 'customer_type.corporate.form.label.bank_account' | translate }} </div>
    <div class="particular__value" *ngIf="!record?.bankAccounts.length">-</div>
    <ng-container *ngFor="let bankAccount of record?.bankAccounts; let i = index">
      <div class="particular__label"> {{ 'customer_type.corporate.form.label.bank_account' | translate }} #{{i+1}}</div>
      <div class="particular__value">{{bankAccount}}</div>
    </ng-container>
  </div>
  <div class="particular" *ngIf="crp?.primary">
    <div class="particular__label">
      {{ 'customer_type.corporate.form.label.customer_reference_number' | translate }}
      <img class="themified-white-icon particular__info-icon" src="/assets/icons/info-icon.png" matTooltip="Unique ID of this case">
    </div>
    <div class="particular__value">{{customer?.referenceId !== '' ? customer?.referenceId : '-'}}</div>
  </div>
  <div class="particular">
    <div class="particular__label">
      {{ 'customer_type.corporate.form.label.reference_number' | translate }}
      <img class="themified-white-icon particular__info-icon" src="/assets/icons/info-icon.png" matTooltip="Unique ID of this individual/corporate">
    </div>
    <div class="particular__value">{{record?.referenceId !== '' ? record?.referenceId : '-'}}</div>
  </div>
  <div class="particular" *ngIf="crp?.primary">
    <div class="particular__label"> {{ 'customer_type.corporate.form.label.nature_of_business_relationship' | translate }} </div>
    <div class="particular__value">{{customer?.natureOfBusinessRelationship !== '' ? customer?.natureOfBusinessRelationship : '-'}}</div>
  </div>
  <div class="particular" *ngIf="!crp?.primary">
    <div class="particular__label"> {{ 'customer_type.corporate.form.label.is_undischarged_bankrupt' | translate }} </div>
    <div class="particular__value">{{record?.isUndischargedBankrupt ? 'YES' : 'NO'}}</div>
  </div>
  <div class="particular" *ngIf="dataAvailableFormFields?.jsonValue?.policyCount?.visible">
    <div class="particular__label">{{ 'customer_type.corporate.form.label.policy_count' | translate }} </div>
    <div class="particular__value">{{customer?.policyCount ? customer?.policyCount : '-'}}</div>
  </div>
  <div class="particular" *ngIf="dataAvailableFormFields?.jsonValue?.premiumAmount?.visible">
    <div class="particular__label"> {{ 'customer_type.corporate.form.label.premium_amount' | translate }} </div>
    <div class="particular__value">{{customer?.premiumAmount ? customer?.premiumAmount : '-'}}</div>
  </div>
</div>
